import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


export default function PaymentSuccess() {
    const params = useParams()
    const { login } = useSelector((item) => item.user);
    const [counter, setCounter] = useState(10);
    var { t } = useTranslation()


    useEffect(() => {
        document.title = t("payment_was_successful");

        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
        if (counter === 0) {
            window.location.href = `/`;
        }
        if (login === false) {
            window.location.href = `/auth`;
        }
    }, [counter]);

    function closeWindow() {
        if (typeof window !== 'undefined') {
            window.location.href = `/`;

        }
    }



    return (
        <>

            <div className="flex flex-col items-center justify-center w-full h-screen">
                <div className="bg-white bg-transparent  rounded-lg shadow-lg p-5 w-[400px]">
                    <div className="flex flex-col items-center justify-center mt-6 space-y-7">
                        <p className="text-xl font-bold">{t("successful_payment")}</p>
                        <p className="text-center text-gray-600 w-80">{t("thank_you_for_payment")}</p>
                    </div>
                    <div className="flex justify-center w-full mt-20 ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={0.7} stroke="currentColor" className="w-32 h-32 text-lime-500">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2 mt-20 ">
                        <button onClick={() => closeWindow()} type="button" className="text-white  bg-lime-600  focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">{t("return_main_page")}</button>
                        <p className="text-sm text-gray-600 " ><span>{counter}</span>  {t("go_to_home_page")} </p>
                        <h4 className="text-xs text-gray-600 ">{t("product_id")} {params.id}</h4>
                    </div>
                </div>
            </div>



        </>
    )
}



